<template>
    <div>
        <ButtonGroup>
            <Button :type="halfYearType" @click="setHalfYear">近半年</Button>
            <Button :type="oneYearType" @click="setOneYear">近一年</Button>
        </ButtonGroup>
        <DatePicker type="month" :value="startTime" placeholder="起始月份" style="width: 200px" @on-change="startChange"></DatePicker>
        <span>~</span>
        <DatePicker type="month" :value="endTime" placeholder="结束月份" style="width: 200px" @on-change="endChange"></DatePicker>
    </div>
</template>
<script>
    export default {
        name: 'LyMonthRange',
        props: {
            value: {
                type: [String],
                default: ''
            }
        },
        data () {
            return {
                startTime: '',
                endTime: '',
                yearRange: {
                    halfYear: '', // 记录近半年的起始时间
                    oneYear: '',// 记录近一年的起始时间
                    endTime: '' // 当前月份
                }
            }
        },
        computed: {
            halfYearType () {
                let type = 'default'
                if (this.startTime == this.yearRange.halfYear && this.endTime == this.yearRange.endTime) {
                    type = 'primary'
                }
                return type
            },
            oneYearType () {
                let type = 'default'
                if (this.startTime == this.yearRange.oneYear && this.endTime == this.yearRange.endTime) {
                    type = 'primary'
                }
                return type
            }
        },
        created () {
            this.initYear()
        },
        methods: {
            /**
             * 初始化时间范围
             */
            initYear () {
                let now = new Date()
                let month = now.getMonth() + 1
                let year = now.getFullYear()
                // 计算近半年
                let half = month - 6
                if (half < 1) {
                    half += 12
                    this.yearRange.halfYear = (year - 1) + '-' + this.getMonthStr(half)
                } else {
                    this.yearRange.halfYear = year + '-' + this.getMonthStr(half)
                }
                // 近一年
                this.yearRange.oneYear = (year - 1) + '-' + this.getMonthStr(month)
                this.yearRange.endTime = year + '-' + this.getMonthStr(month)
            },
            getMonthStr (m) {
                if (m < 10) {
                    m = '0' + m
                }
                return m
            },
            startChange (val) {
                this.startTime = val
                this.inputEmit()
            },
            endChange (val) {
                this.endTime = val
                this.inputEmit()
            },
            setHalfYear () {
                this.startTime = this.yearRange.halfYear
                this.endTime = this.yearRange.endTime
                this.inputEmit()
            },
            setOneYear () {
                this.startTime = this.yearRange.oneYear
                this.endTime = this.yearRange.endTime
                this.inputEmit()
            },
            inputEmit () {
                let val = this.startTime
                if (this.endTime.length > 0) {
                    val += '~' + this.endTime
                }
                this.$emit('input', val)
            }
        }
    }
</script>




// WEBPACK FOOTER //
// ../projectCore/src/components/month-range/src/index.vue